import { render, staticRenderFns } from "./ambience.vue?vue&type=template&id=0265af80"
import script from "./ambience.vue?vue&type=script&lang=js"
export * from "./ambience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0265af80')) {
      api.createRecord('0265af80', component.options)
    } else {
      api.reload('0265af80', component.options)
    }
    module.hot.accept("./ambience.vue?vue&type=template&id=0265af80", function () {
      api.rerender('0265af80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/ambience.vue"
export default component.exports